module.exports = __webpack_public_path__ + "media/audio8.f491a1ae.mp3";